import { useEffect, useState } from 'react';
import { supabase } from '../../config/supabaseClient';
import dayjs from 'dayjs';
import { getTodayDate } from '../HelperFunction/TimezoneDates';
import { getCustomSubtractDate } from '../HelperFunction/TimezoneDates';

interface ContentAvailability {
  [key: string]: boolean;
}

interface ContentCheckResponse {
  data: any[] | null;
  error: any;
}

export const useCheckContentAvailability = (username: string, user_id: string) => {
  const [contentAvailability, setContentAvailability] = useState<ContentAvailability>({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAllContent = async () => {
      try {
        // Check Instagram Stories
        const { data: instagramStoryData }: ContentCheckResponse = await supabase.rpc(
          'get_storytypecontenttteo',
          {
            userid: user_id,
            user_name: username,
            platform_name: 'instagram',
            feed_type: 'STORY',
            start_date: getCustomSubtractDate(7),
            end_date: getTodayDate(),
            order_type: 'false'
          }
        );

        // Check TikTok Posts
        const { data: tiktokData }: ContentCheckResponse = await supabase.rpc(
          'get_tiktoktypecontenttteo',
          {
            userid: user_id,
            user_name: username,
            platform_name: 'tiktok',
            feed_type: 'TIKTOK',
            order_type: 'false'
          }
        );

        // Check Instagram Reels
        const { data: reelsData }: ContentCheckResponse = await supabase.rpc(
          // 'get_typecontentteo',
          "get_contenttypeposts",
          {
            userid: user_id,
            user_name: username,
            platform_name: 'instagram',
            feed_type: 'REELS',
            order_type: 'false'
          }
        );
        // Check YouTube Videos
        const { data: youtubeData }: ContentCheckResponse = await supabase.rpc(
          'get_contenttypeposts',
          {
            userid: user_id,
            user_name: username,
            platform_name: 'youtube',
            feed_type: 'VIDEO',
            order_type: 'false'
          }
        );

        // Check Podcast Episodes
        const { data: podcastData }: ContentCheckResponse = await supabase.rpc(
          'get_contenttypeposts',
          {
            userid: user_id,
            user_name: username,
            platform_name: 'podcast',
            feed_type: 'PODCAST',
            order_type: 'false'
          }
        );

        // Check Twitter Posts
        const { data: twitterData }: ContentCheckResponse = await supabase.rpc(
          'get_contenttypeposts',
          {
            userid: user_id,
            user_name: username,
            platform_name: 'twitter',
            feed_type: 'TWEET',
            order_type: 'false'
          }
        );

        // Check LinkedIn Posts
        const { data: linkedinData }: ContentCheckResponse = await supabase.rpc(
          'get_contenttypeposts',
          {
            userid: user_id,
            user_name: username,
            platform_name: 'linkedin',
            feed_type: 'POST',
            order_type: 'false'
          }
        );

        // Check Featured Content
        const { data: featuredData }: ContentCheckResponse = await supabase.rpc(
          'get_featuredddataaee',
          {
            userid: user_id,
            filter: [
              "FEED",
              "REELS",
              "STORY",
              "HIGHLIGHTS",
              "PIN",
              "VIDEO",
              "PODCAST",
              "TIKTOK",
              "MAIL",
              "TWEET",
              "PRODUCT",
              "POST"
            ],
            query_str: "",
            user_name: username,
            socials: [
              "instagram",
              "youtube",
              "tiktok",
              "podcast",
              "pinterest",
              "newsletter",
              "twitter",
              "LTK",
              "Amazon",
              "ShopMy",
              "MISC",
              "linkedin",
              "MISC-content"
            ],
          }
        );

        setContentAvailability({
          instagram: Array.isArray(instagramStoryData) && instagramStoryData.length > 0,
          tiktok: Array.isArray(tiktokData) && tiktokData.length > 0,
          reels: Array.isArray(reelsData) && reelsData.length > 0,
          youtube: Array.isArray(youtubeData) && youtubeData.length > 0,
          podcast: Array.isArray(podcastData) && podcastData.length > 0,
          twitter: Array.isArray(twitterData) && twitterData.length > 0,
          linkedin: Array.isArray(linkedinData) && linkedinData.length > 0,
          featured: Array.isArray(featuredData) && featuredData.length > 0,
        });
      } catch (error) {
        console.error('Error checking content availability:', error);
        setContentAvailability({});
      } finally {
        setIsLoading(false);
      }
    };

    if (username && user_id) {
      checkAllContent();
    }
  }, [username, user_id]);

  return { contentAvailability, isLoading };
}; 